export default "__VITE_ASSET__BmVjo0Uo__"